import { DeliveryZone, GQL_ID } from '@@types'
import { useQuery } from '@apollo/client'

import { GQL_SINGLE_DELIVERY_ZONE } from '../api/graphql'

interface SingleDeliveryZoneQuery {
  singleDeliveryZone: DeliveryZone
}

interface SingleDeliveryZoneVariables {
  id: GQL_ID
}

interface UseSingleDeliveryZoneProps {
  id?: GQL_ID | null
  skip?: boolean
}

/**
 * Хук для получения одной зоны доставки по ID
 * Аналог useFetchSingleDeliveryZone из приложения
 */
export function useSingleDeliveryZone ({
  id,
  skip: externalSkip = false,
}: UseSingleDeliveryZoneProps) {
  const skip = externalSkip || !id

  const { data, loading, error, refetch } = useQuery<
    SingleDeliveryZoneQuery,
    SingleDeliveryZoneVariables
  >(GQL_SINGLE_DELIVERY_ZONE, {
    variables: {
      id: id!,
    },
    skip,
  })

  const deliveryZone = data?.singleDeliveryZone ?? null

  return {
    deliveryZone,
    data,
    loading,
    error,
    refetch,
  }
}
